export default function startEasyTrackUploading(payload) {
  return function(dispatch) {
    dispatch({
      type: 'START_TRACK_UPLOADING',
      payload: {
        uploadingUid: payload.uploadingUid
      }
    });

    let checkProgress = function () {
      fetch(REST_URL+'uploader/getUploadingStatus/uploadingUid/'+payload.uploadingUid, {
        method: 'GET',
        credentials: 'include'
      })
      .then((response) => {
        try {  return response.json() }
        catch(e) {
          setTimeout(checkProgress, 1000);
        }
      })
      .then((json) => {
        if (!json) {
          return;
        }

        if (json.status === 'ok') {
          dispatch({
            type: 'TRACK_UPLOADING_PROGRESS_CHANGE',
            payload: {
              uploadingUid: json.uploadingUid,
              progress: json.progress
            }
          });
        }

        if (json.status !== 'complete') {
          setTimeout(checkProgress, 1000);
        }
      });
    };

    setTimeout(checkProgress, 1000);

    fetch(REST_URL + 'uploader/trackEasyUpload', {
      method: 'POST',
      body: payload.form,
      credentials: 'include'
    }).then((response) => {
      return response.json();
    })
    .then(json => {
      dispatch({
        type: 'TRACK_UPLOADING_COMPLETE',
        payload: {
          uploadingUid: payload.uploadingUid,
          item: json.item
        }
      });
    });
  }
};
